import React from 'react';
import { HomeValuationForm } from './HomeValuationForm';
import { HeroBackground } from './hero/HeroBackground';
import { HeroIdentity } from './hero/HeroIdentity';
import { HeroSearchBar } from './hero/HeroSearchBar';
import { HeroActions } from './hero/HeroActions';
import { HeroSocialLinks } from './hero/HeroSocialLinks';
import { HeroCallBanner } from './hero/HeroCallBanner';

export const HeroSection = ({ searchQuery, setSearchQuery, handleSearch, openGuideModal, openPrivacyPolicy }) => (
  <section id="home" className="relative min-h-screen flex items-center pt-32 pb-12 sm:pt-36 sm:pb-20 overflow-hidden" aria-labelledby="hero-heading">
    <HeroBackground />

    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 w-full">
      <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 items-center">
        <div className="space-y-6 sm:space-y-10 animate-fadeInUp">
          <div className="flex flex-col items-center lg:items-start space-y-6 sm:space-y-8">
            <HeroIdentity />

            <div className="w-full max-w-xl mt-8">
              <HeroSearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} handleSearch={handleSearch} />
              <HeroActions openGuideModal={openGuideModal} />
              <HeroSocialLinks />
            </div>

            <HeroCallBanner />
          </div>
        </div>

        <HomeValuationForm openPrivacyPolicy={openPrivacyPolicy} headingLevel="h2" />
      </div>
    </div>
  </section>
);
